

















import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { UserDto } from "@/store/users/user.interface";

@Component
export default class AppUserItem extends Vue {
  @Prop() item: UserDto;
}
